import { useMemo } from 'react';
import { useAuthStore } from '../store/authStore';

export function useEmploymentRole() {
  const user = useAuthStore((s) => s.user);

  const assignedReportTypes = useMemo(
    () =>
      (user?.employmentRole?.rates ?? [])
        .filter((rt) => rt.reportType.isActive)
        .map((rt) => ({ ...rt.reportType, fieldOverrides: rt.fieldOverrides })),
    [user?.employmentRole],
  );

  return {
    hasEmploymentRole: !!user?.employmentRoleId,
    employmentRole: user?.employmentRole ?? null,
    assignedReportTypes,
    defaultReportTypeCode: user?.employmentRole?.defaultReportTypeCode ?? null,
    canCreateReports: !!user?.employmentRoleId && assignedReportTypes.length > 0,
  };
}
